(function($) {

    /**
     * Liste der Vendors, deren iframes automatische Höhe habe können (setzt Einbindung und Aufruf eines Skripts
     * seitens des Vendors voraus – siehe https://github.com/Sly777/Iframe-Height-Jquery-Plugin).
     *
     * Der angegebene String muss Teil der src-URL des iframes sein. Da diese iframes z. T. in wfDynamic durch Kunden
     * eingebettet werden und unterschiedliche URLs haben können, nutzen wir defensiv partielle Strings.
     *
     * Bsp.: "perbit" stellvertretend für "https://g-ba-jobs.perbit-job.de/?list=2"
     *
     * @type {string[]}
     */
    var sources = ['perbit', 'ais'];

    var options = {
        resizeMaxTry: 10,
        minimumHeight: 150,
        defaultHeight: 150,
    };

    /**
     * NodeList.forEach Polyfill
     * @src https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
     */
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }

    /**
     *
     * @param $iframes
     * @param source
     */
    function initIframeHeight($iframes, source) {
        let immediatelyVisibleIframes = [];
        let disclosableIframes = [];

        $iframes.each(function(index, iframe) {
            var $iframe = $(iframe);
            var iframeUniqueId = source + '-iframe-' + index;

            // Exit early (behandle nur iframes, die wir noch nicht "gesehen" haben)
            if ($iframe.attr('id') === iframeUniqueId) {
                return;
            }

            $iframe.attr('id', iframeUniqueId);

            // Wir müssen zunächst checken, ob das iframe als parent Kontext eine Disclosure hat (bisher nur Akkordeon
            // supported) und initial versteckt sein könnte. Wir sortieren die Iframes in zwei Listen, die wir dann
            // getrennt und spezifisch abarbeiten.
            //
            // TODO: für Tabs und einklappbarer-Ausschnitt erweitern; dazu müssen diese Komponenten Events feuern,
            //  die wir dann in gba.domchanges-manager.js eintragen können.
            var $disclosureParent = $iframe.closest('.js-accordion-group');

            if ($disclosureParent.length === 0) {
                immediatelyVisibleIframes.push($iframe)
            } else {
                disclosableIframes.push($iframe);
            }
        });

        // Immer sichtbare Iframes können sofort abgearbeitet werden
        immediatelyVisibleIframes.forEach(function (iframe) {
            $(iframe).iframeHeight(options);
        });

        // Iframes mit einem Disclosure-Parent arbeiten wir erst ab, wenn das Event "gba.domchanges.completed" fällt.
        // Dazu registrieren wir einen MutationObserver, der das iframe parent panel und seine a11y-Attribute beobachtet,
        // die zu diesem Zeitpunkt sicher via JS erzeugt worden sind.
        window.addEventListener('gba.domchanges.completed', function() {
            disclosableIframes.forEach(function(iframe) {
                var $iframe = $(iframe);

                var observer = new MutationObserver(function(mutationsList, observer) {
                    mutationsList.forEach(function(mutation) {
                        $iframe.iframeHeight(options);
                        observer.disconnect(); // Skript muss pro iframe nur einmalig ausgeführt werden!
                    });
                });

                var $observationTarget = $iframe.closest('.js-accordion__panel', '[data-atabs-panel]');

                var isOpenAccordionPanel = $observationTarget.hasClass('js-accordion__panel') && $observationTarget.attr('aria-hidden') === 'false';
                var isOpenTabPanel = $observationTarget.attr('[data-atabs-panel]') && !$observationTarget.attr('hidden');

                if (isOpenAccordionPanel || isOpenTabPanel) {
                    $iframe.iframeHeight(options);
                } else {
                    observer.observe($observationTarget.get(0), {
                        attributes: true,
                        attributeFilter: ['aria-hidden', 'hidden'],
                    });
                }
            });
        });
    }

    var $iframeSources = $(sources);

    $iframeSources.each(function(index, source) {
        var $iframes = $('iframe[src*="' + source + '"]'); // sammle alle iframes eines vendors

        initIframeHeight($iframes, source);
    });

})(jQuery);
